export default "__VITE_ASSET__CsnsPb8S__"